import { render, staticRenderFns } from "./responsibilities.vue?vue&type=template&id=272972c8&scoped=true"
import script from "./responsibilities.vue?vue&type=script&lang=js"
export * from "./responsibilities.vue?vue&type=script&lang=js"
import style0 from "./responsibilities.vue?vue&type=style&index=0&id=272972c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272972c8",
  null
  
)

export default component.exports